import {Order, OrderStatus} from "../../../app/models/order";
import {Root} from "../../../app/stores/store-root";


export type FormBehavior = {
    ShowPayOrderFields: boolean,
    EnableOrderFormFields: boolean,
    ShowOrderActionsMenu: boolean
}
export const status = (value: string): string => {
    return OrderStatus[parseInt(value.toString())]
}

export const NewOrderFormBehaviour: FormBehavior = {
    ShowPayOrderFields: false,
    EnableOrderFormFields: true,
    ShowOrderActionsMenu: false
}

export const FormBehaviourRules = [

    //Admin Rules
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'PendingReview')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: true, ShowPayOrderFields: false, EnableOrderFormFields: true}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'ReadyForCollection')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: true, ShowPayOrderFields: false, EnableOrderFormFields: true}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Rejected')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Cancelled')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Paid' && order.DeliveryType === '0')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'Paid' && order.DeliveryType === '1')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: true, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isAdmin && status(order.Status) === 'InProgress')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },

    //Sending Agent Rules
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'PendingReview')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: true}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'ReadyForCollection' )
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'Rejected')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'Cancelled')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'Paid')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: true, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return (store.Users.isSendingAgent && status(order.Status) === 'InProgress')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: true, EnableOrderFormFields: false}
        }
    },

    //Receiving Agent Rules
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'PendingReview')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor )&& status(order.Status) === 'ReadyForCollection' && order.DeliveryType ==='0')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: true, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor )&& status(order.Status) === 'ReadyForCollection' && order.DeliveryType ==='1')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: true, ShowPayOrderFields: true, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor )&& status(order.Status) === 'Rejected')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor )&& status(order.Status) === 'Cancelled')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor )&& status(order.Status) === 'Paid' && order.DeliveryType === '0')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor )&& status(order.Status) === 'Paid' && order.DeliveryType === '1')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: false, ShowPayOrderFields: true, EnableOrderFormFields: false}
        }
    },
    {
        match: (order: Order, store: Root): boolean => {
            return ((store.Users.isReceiveAgent || store.Users.isCashier || store.Users.isSupervisor) && status(order.Status) === 'InProgress')
        },
        action: (): FormBehavior => {
            return {ShowOrderActionsMenu: true, ShowPayOrderFields: true, EnableOrderFormFields: false}
        }
    }
]

export const CalculateFormBehaviour = (order: Order, store: Root): FormBehavior => {
    for (var rule of FormBehaviourRules) {
        if (rule.match(order, store))
            return rule.action();
    }
    return {ShowOrderActionsMenu: false, ShowPayOrderFields: false, EnableOrderFormFields: false};
}

/*
if Sending Agend or Admin
Actions False
beneficatry fields false
form true

if sending agent and Pending Review then
Actions false
Beneficary fields false
form true


if Admin and Pending Review then
Actions true
beneficary feilds false
form true

if Sending agent or Approved or Rejected
Actions false
Bene false
form false

if Admin and approved
Actions true
Beneficary fields false
form true

if Admin and rejected
Actions false
Beneficary fields false
form false

if receieving agent and ready
Actions true
Beneficary fields true
form false

if receieving agent and in progress
Actions true
Beneficary fields true
form false

if receieving agent and Paid
Actions false
Beneficary fields false
form false








* */
